/**
 * Meta Pixel + Shopify cart config.
 * Everything that ever needs changing lives in this one object.
 */
export const CHECKOUT_CONFIG = {
  pixelId: '676572141744167',
  shop: 'https://myeasyguide.online',
  plans: {
    complete: {
      url: 'https://myeasyguide.online/cart/49960131133682:1',
      variantId: '49960131133682',
      contentName: 'Calm Mornings Complete',
      value: 37.0,
    },
    starter: {
      url: 'https://myeasyguide.online/cart/49960130478322:1',
      variantId: '49960130478322',
      contentName: 'Calm Mornings Starter',
      value: 27.0,
    },
  },
  /** Upsell variant IDs — replace each placeholder with the real Shopify variant ID. */
  upsellVariants: {
    upgrade: 'REPLACE_UPGRADE_7_ID',
    braveMind: 'REPLACE_BRAVE_MIND_89_ID',
    littleEngineer: 'REPLACE_LITTLE_ENGINEER_1999_ID',
    focusLab: 'REPLACE_FOCUS_LAB_1999_ID',
  },
} as const

export type CheckoutPlanId = keyof typeof CHECKOUT_CONFIG.plans
export type UpsellVariantId = keyof typeof CHECKOUT_CONFIG.upsellVariants

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
    __metaPixelInitialized?: boolean
  }
}

/** Injects the base code. Safe to call more than once — init only ever runs once. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.__metaPixelInitialized) return
  window.__metaPixelInitialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode?.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  /* eslint-enable */

  window.fbq?.('init', CHECKOUT_CONFIG.pixelId)
  window.fbq?.('track', 'PageView')
  window.fbq?.('track', 'ViewContent', {
    content_name: 'Calm Mornings Mega Kit',
    content_type: 'product',
    value: 37.0,
    currency: 'USD',
  })

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${CHECKOUT_CONFIG.pixelId}&ev=PageView&noscript=1`
  img.alt = ''
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

type CheckoutOptions = {
  /** Extra upsell keys the buyer checked in the modal. */
  extras?: UpsellVariantId[]
  /** Order total, including the extras. Defaults to the plan price. */
  value?: number
}

/**
 * Fires InitiateCheckout, then navigates to the Shopify cart permalink in the
 * same tab. With no extras it goes straight to the plan's own permalink.
 */
export function startCheckout(planId: CheckoutPlanId, options: CheckoutOptions = {}): void {
  const plan = CHECKOUT_CONFIG.plans[planId]
  const extras = options.extras ?? []
  const extraIds = extras.map(key => CHECKOUT_CONFIG.upsellVariants[key])

  const url =
    extraIds.length === 0
      ? plan.url
      : `${CHECKOUT_CONFIG.shop}/cart/${[
          `${plan.variantId}:1`,
          ...extraIds.map(id => `${id}:1`),
        ].join(',')}`

  window.fbq?.('track', 'InitiateCheckout', {
    value: options.value ?? plan.value,
    currency: 'USD',
    content_name: plan.contentName,
    content_ids: [plan.variantId, ...extraIds],
    content_type: 'product',
  })

  window.setTimeout(() => {
    window.location.href = url
  }, 150)
}
